import { IUsageProfileDetailed } from "@/services/UsageEstimationService/types"

const usageProfiles: IUsageProfileDetailed[] = [
  {
    cooking: "Gas",
    heating: "Gas",
    bedrooms: 1,
    gasUsage: 8560.0,
    electricityUsage: 1779.0,
    electricityTwoRateUsage: 2557.3125,
  },
  {
    cooking: "Gas",
    heating: "Gas",
    bedrooms: 2,
    gasUsage: 11156.0,
    electricityUsage: 2223.0,
    electricityTwoRateUsage: 3196.0,
  },
  {
    cooking: "Gas",
    heating: "Gas",
    bedrooms: 3,
    gasUsage: 16346.0,
    electricityUsage: 2778.0,
    electricityTwoRateUsage: 3993.0,
  },
  {
    cooking: "Gas",
    heating: "Gas",
    bedrooms: 4,
    gasUsage: 22469.0,
    electricityUsage: 3474.0,
    electricityTwoRateUsage: 4994.0,
  },
  {
    cooking: "Gas",
    heating: "Gas",
    bedrooms: 5,
    gasUsage: 30057.0,
    electricityUsage: 4341.0,
    electricityTwoRateUsage: 6240.0,
  },
  {
    cooking: "Gas",
    heating: "Electricity",
    bedrooms: 1,
    gasUsage: 2567.0,
    electricityUsage: 3669.0,
    electricityTwoRateUsage: 5274.0,
  },
  {
    cooking: "Gas",
    heating: "Electricity",
    bedrooms: 2,
    gasUsage: 3121.0,
    electricityUsage: 4855.0,
    electricityTwoRateUsage: 6979.0,
  },
  {
    cooking: "Gas",
    heating: "Electricity",
    bedrooms: 3,
    gasUsage: 3784.0,
    electricityUsage: 7113.0,
    electricityTwoRateUsage: 10225.0,
  },
  {
    cooking: "Gas",
    heating: "Electricity",
    bedrooms: 4,
    gasUsage: 4586.0,
    electricityUsage: 10299.0,
    electricityTwoRateUsage: 14805.0,
  },
  {
    cooking: "Gas",
    heating: "Electricity",
    bedrooms: 5,
    gasUsage: 5557.0,
    electricityUsage: 12388.0,
    electricityTwoRateUsage: 17808.0,
  },
  {
    cooking: "Gas",
    heating: "Other",
    bedrooms: 1,
    gasUsage: 2567.0,
    electricityUsage: 1779.0,
    electricityTwoRateUsage: 2557.0,
  },
  {
    cooking: "Gas",
    heating: "Other",
    bedrooms: 2,
    gasUsage: 3121.0,
    electricityUsage: 2223.0,
    electricityTwoRateUsage: 3196.0,
  },
  {
    cooking: "Gas",
    heating: "Other",
    bedrooms: 3,
    gasUsage: 3784.0,
    electricityUsage: 2778.0,
    electricityTwoRateUsage: 3993.0,
  },
  {
    cooking: "Gas",
    heating: "Other",
    bedrooms: 4,
    gasUsage: 4586.0,
    electricityUsage: 3474.0,
    electricityTwoRateUsage: 4994.0,
  },
  {
    cooking: "Gas",
    heating: "Other",
    bedrooms: 5,
    gasUsage: 5557.0,
    electricityUsage: 4341.0,
    electricityTwoRateUsage: 6240.0,
  },
  {
    cooking: "Electricity",
    heating: "Gas",
    bedrooms: 1,
    gasUsage: 7743.0,
    electricityUsage: 3161.0,
    electricityTwoRateUsage: 4544.0,
  },
  {
    cooking: "Electricity",
    heating: "Gas",
    bedrooms: 2,
    gasUsage: 10222.0,
    electricityUsage: 3803.0,
    electricityTwoRateUsage: 5467.0,
  },
  {
    cooking: "Electricity",
    heating: "Gas",
    bedrooms: 3,
    gasUsage: 15296.0,
    electricityUsage: 4557.0,
    electricityTwoRateUsage: 6551.0,
  },
  {
    cooking: "Electricity",
    heating: "Gas",
    bedrooms: 4,
    gasUsage: 21301.0,
    electricityUsage: 5451.0,
    electricityTwoRateUsage: 7836.0,
  },
  {
    cooking: "Electricity",
    heating: "Gas",
    bedrooms: 5,
    gasUsage: 28773.0,
    electricityUsage: 6516.0,
    electricityTwoRateUsage: 9367.0,
  },
  {
    cooking: "Electricity",
    heating: "Electricity",
    bedrooms: 1,
    gasUsage: 1750.0,
    electricityUsage: 5052.0,
    electricityTwoRateUsage: 7262.0,
  },
  {
    cooking: "Electricity",
    heating: "Electricity",
    bedrooms: 2,
    gasUsage: 2188.0,
    electricityUsage: 6435.0,
    electricityTwoRateUsage: 9250.0,
  },
  {
    cooking: "Electricity",
    heating: "Electricity",
    bedrooms: 3,
    gasUsage: 2734.0,
    electricityUsage: 8892.0,
    electricityTwoRateUsage: 12782.0,
  },
  {
    cooking: "Electricity",
    heating: "Electricity",
    bedrooms: 4,
    gasUsage: 3418.0,
    electricityUsage: 12276.0,
    electricityTwoRateUsage: 17647.0,
  },
  {
    cooking: "Electricity",
    heating: "Electricity",
    bedrooms: 5,
    gasUsage: 4273.0,
    electricityUsage: 14563.0,
    electricityTwoRateUsage: 20934.0,
  },
  {
    cooking: "Electricity",
    heating: "Other",
    bedrooms: 1,
    gasUsage: 1750.0,
    electricityUsage: 3161.0,
    electricityTwoRateUsage: 4544.0,
  },
  {
    cooking: "Electricity",
    heating: "Other",
    bedrooms: 2,
    gasUsage: 2188.0,
    electricityUsage: 3803.0,
    electricityTwoRateUsage: 5467.0,
  },
  {
    cooking: "Electricity",
    heating: "Other",
    bedrooms: 3,
    gasUsage: 2734.0,
    electricityUsage: 4557.0,
    electricityTwoRateUsage: 6551.0,
  },
  {
    cooking: "Electricity",
    heating: "Other",
    bedrooms: 4,
    gasUsage: 3418.0,
    electricityUsage: 5451.0,
    electricityTwoRateUsage: 7836.0,
  },
  {
    cooking: "Electricity",
    heating: "Other",
    bedrooms: 5,
    gasUsage: 4273.0,
    electricityUsage: 6516.0,
    electricityTwoRateUsage: 9367.0,
  },
]

export default usageProfiles
